import React from 'react'
import { Button, Heading, Text, UIProvider } from '../UI'
import { Link as MagnoliaLink } from 'src/components/Magnolia'
import * as PromoCTASectionStyles from './PromoCTASection.styles'

type PromoCTASection = React.ComponentPropsWithoutRef<'div'> & {
  title: string
}

const PromoCTASection: React.FC<PromoCTASection> = props => {
  const { children, title } = props
  return (
    <UIProvider>
      <PromoCTASectionStyles.Container>
        <div className="promo-footer">
          <div className="promo-footer__background" />
          <div className="promo-footer__container">
            <div className="promo-footer__greeting">
              <Heading
                fontFamily={['Roboto', 'Lexend']}
                fontWeight={['700', '700']}
                fontSize={['24px', '40px']}
                lineHeight={['28px', '52px']}
                letterSpacing={['-0.24px', '0.005em']}
                color={['#383838', '#383838']}
              >
                {title}
              </Heading>
              <Text
                fontFamily={['Roboto', 'Roboto']}
                fontWeight={['400', '400']}
                fontSize={['16px', '16px']}
                lineHeight={['24px', '24px']}
                letterSpacing={['normal', 'normal']}
                color={['#666666', '#666666']}
              >
                {children}
              </Text>
            </div>
            <div className="promo-footer__button">
              <MagnoliaLink href="/promo-dan-penawaran">
                <Button variant="outlined" backgroundColor="transparent" borderRadius="20px">
                  Cek Promo di Sini
                </Button>
              </MagnoliaLink>
            </div>
          </div>
        </div>
      </PromoCTASectionStyles.Container>
    </UIProvider>
  )
}

export default PromoCTASection
